import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { 
  TrophyOutlined,
  CloudServerOutlined,
  CodeOutlined,
  ApiOutlined,
  DeploymentUnitOutlined,
  DatabaseOutlined
} from '@ant-design/icons';
import './Projects.css';
import about1 from '../../src/assets/image/about/about1.jpg';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const Projects = () => {
  return (
    <Content style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div className="about-photo-row">
        {[about1].map((img, index) => (
          <img key={index} src={img} alt={`About ${index + 1}`} className="about-photo" />
        ))}
      </div>

      <Title level={2} className="section-title">About Me</Title>
      <div className="tagline-container">
        <Text className="tagline">☁ AWS Cloud Engineer</Text>
        <Text className="tagline">💻 Full-Stack Developer</Text>
        <Text className="tagline">📊 Data Science Enthusiast</Text>
      </div>

      <Paragraph className="intro-text">
        I’m a Cloud Engineer and Software Developer with expertise in building scalable applications, 
        architecting cloud solutions, and leveraging data to drive insights. My experience spans across 
        AWS cloud deployments, full-stack development, DevOps automation, and data science projects. 
        I thrive in client-facing roles where I simplify technical concepts for non-technical audiences, 
        ensuring smooth collaboration and project success.
      </Paragraph>

      <Row gutter={[24, 24]} style={{ marginTop: '40px' }}>
        <Col xs={24} md={12}>
          <Card
            title={<span className="card-title"><CloudServerOutlined /> AWS & Cloud Solutions</span>}
            className="about-card"
          >
            <Paragraph>
              - Designed and deployed enterprise-grade solutions on AWS, including microservices architectures  
              - Implemented CI/CD pipelines, automated deployments, and optimized cloud resources  
              - Certified AWS Solutions Architect – Associate & AWS Cloud Practitioner
            </Paragraph>
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={<span className="card-title"><CodeOutlined /> Full-Stack Development</span>}
            className="about-card"
          >
            <Paragraph>
              - Developed and maintained applications using React.js, Node.js, Spring Boot  
              - Built secure, scalable database architectures for private network environments  
              - Experienced in Python, SQL, and API integrations for business solutions
              - Created and trained prediction models for Stock Market Trading
            </Paragraph>
          </Card>
        </Col>
      </Row>

      <Card
        title={<span className="card-title"><ApiOutlined /> Data Science & Automation</span>}
        className="about-card"
        style={{ marginTop: '24px' }}
      >
        <Paragraph>
          - Built machine learning models for predictive analytics and forecasting  
          - Automated workflows using Python, VBA, and data pipelines  
          - Created interactive dashboards and visualizations for investment & operational data
        </Paragraph>
      </Card>
      <Card
  title={<span className="card-title"><CodeOutlined /> Crypto & Security Projects</span>}
  className="about-card"
  style={{ marginTop: '24px' }}
>
  <Paragraph>
    - Studied the Discrete Logarithm Problem and its relevance to cryptographic security  
    - Implemented the Pohlig-Hellman algorithm using Python to exploit weaknesses in Diffie-Hellman key exchange  
    - Demonstrated how unsafe primes (where p-1 has small prime factors) make systems vulnerable to efficient attacks  
    - Compared performance against safe primes and analyzed how factor size impacts cryptographic strength
  </Paragraph>
</Card>


   
      <Card
        title={<span className="card-title"><DeploymentUnitOutlined /> How I Can Help</span>}
        className="services-card"
        style={{ marginTop: '24px' }}
      >
        <Title level={4}>Areas of Focus</Title>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><CloudServerOutlined /> Cloud Architecture</Title>
              <Text>Design and deploy secure, scalable cloud infrastructures on AWS</Text>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><DatabaseOutlined /> Database Solutions</Title>
              <Text>Database design, optimization, and management for enterprise systems</Text>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Card className="service-card">
              <Title level={5}><CodeOutlined /> Full-Stack Applications</Title>
              <Text>Custom web and mobile solutions tailored to client needs</Text>
            </Card>
          </Col>
        </Row>
      </Card>
    </Content>
  );
};

export default Projects;
